import * as React from "react"
import { RouteComponentProps } from "@gatsbyjs/reach-router"
import { Login as LoginScreen } from "@modules/user/login/components/Login"

export function Login(props: RouteComponentProps) {
  return <LoginScreen {...props} />
}
